import { render, staticRenderFns } from "./settlement_items_detail_add.vue?vue&type=template&id=561d57dd&"
import script from "./settlement_items_detail_add.vue?vue&type=script&lang=ts&"
export * from "./settlement_items_detail_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports